import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { logger } from 'redux-logger';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import Reducer from './reducers';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import levlrLogo from './img/LEVLR Logo_CMYK.png';

// Redux store setup
const store = createStore(Reducer, applyMiddleware(thunk, logger));

// WelcomeMessage component
const WelcomeMessage = ({ onClose }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      padding: '48px',
      textAlign: 'center',
      minHeight: '80vh',
      backgroundColor: '#fff',
      position: 'relative',
    }}
  >
    <button
      onClick={onClose}
      style={{
        position: 'fixed',
        top: '20px',
        right: '20px',
        background: 'none',
        border: 'none',
        fontSize: '24px',
        cursor: 'pointer',
        color: '#333',
      }}
      aria-label="Close"
    >
      ✕
    </button>

    <a href="/login">
      <img style={{ width: '300px', height: 'auto' }} src={levlrLogo} alt="LEVLR Logo" />
    </a>
    <br /><br /><br /><br />

    <h1 style={{ fontSize: '32px' }}>Welcome to LEVLR!</h1>
    <br /><br />

    <p style={{ fontSize: '20px' }}>
      Thank you for signing up! We’re excited to have you on board and can’t wait for you to experience the power of our AI-driven solution.
    </p>
    <br />

    <p style={{ fontSize: '20px' }}>
      For the best experience, we recommend using our platform on a desktop. We’ve also sent a welcome email – be sure to check it out!
    </p>
    <br />

    <p style={{ fontSize: '20px' }}>
      Let’s get to work saving you time and boosting your revenue!
    </p>
  </div>
);

// Main component
const MainComponent = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1200 || window.innerHeight < 700);
  const [currentPath, setCurrentPath] = useState(window.location.pathname);
  const [showMessage, setShowMessage] = useState(true);

  // Update isMobile on resize
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1200 || window.innerHeight < 700);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Track client-side navigation
  useEffect(() => {
    const handlePathChange = () => setCurrentPath(window.location.pathname);

    // Monkey-patch history.pushState and history.replaceState to detect navigation
    const originalPush = window.history.pushState;
    const originalReplace = window.history.replaceState;

    window.history.pushState = function (...args) {
      originalPush.apply(this, args);
      handlePathChange();
    };

    window.history.replaceState = function (...args) {
      originalReplace.apply(this, args);
      handlePathChange();
    };

    window.addEventListener('popstate', handlePathChange);

    return () => {
      window.history.pushState = originalPush;
      window.history.replaceState = originalReplace;
      window.removeEventListener('popstate', handlePathChange);
    };
  }, []);

  const allowedPaths = ['/login', '/register', '/forgot', '/'];
  const isAllowedPath = allowedPaths.includes(currentPath);

  if (isMobile && !isAllowedPath && showMessage) {
    return <WelcomeMessage onClose={() => setShowMessage(false)} />;
  }

  return <App />;
};

// Render
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <MainComponent />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
